'use client'

import {
  Icon as Iconify,
  type IconifyIconProps
} from '@iconify/react/dist/iconify.js'
import { memo } from 'react'

export interface IconProps extends IconifyIconProps {
  className?: string
}

const Icon = ({ className, icon }: IconProps) => (
  <Iconify className={className} icon={icon} />
)

Icon.displayName = 'Icon'

export default memo(Icon)
